export default __webpack_public_path__ + "static/media/007-boy-2.946b8373.svg";